var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999837 13.8333C0.999837 14.75 1.74984 15.5 2.6665 15.5H9.33317C10.2498 15.5 10.9998 14.75 10.9998 13.8333V5.5C10.9998 4.58333 10.2498 3.83333 9.33317 3.83333H2.6665C1.74984 3.83333 0.999837 4.58333 0.999837 5.5V13.8333ZM10.9998 1.33333H8.9165L8.32484 0.741667C8.17484 0.591667 7.95817 0.5 7.7415 0.5H4.25817C4.0415 0.5 3.82484 0.591667 3.67484 0.741667L3.08317 1.33333H0.999837C0.541504 1.33333 0.166504 1.70833 0.166504 2.16667C0.166504 2.625 0.541504 3 0.999837 3H10.9998C11.4582 3 11.8332 2.625 11.8332 2.16667C11.8332 1.70833 11.4582 1.33333 10.9998 1.33333Z",
    fill: "#19262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashBin);
export default __webpack_public_path__ + "static/media/IconTrashBin.39421066b13cee6fcb997d738ffcb4cd.svg";
export { ForwardRef as ReactComponent };